export const environment = {
    production: false,
    challengeChangeConfirmationText: 'YES',

    apiBaseUrl: 'https://www.devbackend.digimaker.com.au:444',
    tutorAttendancePath: '/api/v2/attendance/tutor',
    adminAttendancePath: '/api/v2/attendance/admin',
    batchesPath: '/api/v2/batches',
    interstFormPath: '/api/v2/interstForm',
    attendancePath: '/api/v2/attendances',
    makeupClass: '/api/v2/makeupClass',
    emailTemplateMasterPath: '/api/v2/emailConfig',
    //New
    challengesPath: '/api/v3/challenge',
    environmentType: "DEV",
    environmentTheme: "#008000",

    apiUrl: 'https://www.devbackend.digimaker.com.au:444/user/',
    projectUrl: 'https://www.devbackend.digimaker.com.au:444/user/',
    csvUrl: 'https://www.devbackend.digimaker.com.au:444/user/bulky?api=core',
    ideLaunch: 'https://www.devbackend.digimaker.com.au:444/project/launch?api=util',
    projectsTypeUrl: 'https://www.devbackend.digimaker.com.au:444/project/getProjectsTypeList?api=util',
    sampleBulkDownloadURL:
        'https://digimaker-dev-files.s3.ap-southeast-2.amazonaws.com/bulkRegistration/bulk_registration_sample.csv',
    sampleBulkUpdateDownloadURL:
        'https://digimaker-dev-files.s3.ap-southeast-2.amazonaws.com/bulkRegistration/bulk_update_sample.csv',
    BulkReqDownloadURL:
        'https://digimaker-dev-files.s3.ap-southeast-2.amazonaws.com/bulkRegistration',
    sampleExceptionStudentIdsURL:
    'https://digimaker-dev-files.s3.ap-southeast-2.amazonaws.com/bulkRegistration/userIds_sample.csv',
};
